"use strict";

function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttributeMap = exports.OpIterator = exports.Op = void 0;
var _diff = require("fast-diff");
var cloneDeep = require("lodash.clonedeep");
var isEqual = require("lodash.isequal");
var AttributeMap_1 = require("./AttributeMap");
exports.AttributeMap = AttributeMap_1["default"];
var Op_1 = require("./Op");
exports.Op = Op_1["default"];
var OpIterator_1 = require("./OpIterator");
exports.OpIterator = OpIterator_1["default"];
var NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
var getEmbedTypeAndData = function getEmbedTypeAndData(a, b) {
  if (_typeof(a) !== 'object' || a === null) {
    throw new Error("cannot retain a ".concat(_typeof(a)));
  }
  if (_typeof(b) !== 'object' || b === null) {
    throw new Error("cannot retain a ".concat(_typeof(b)));
  }
  var embedType = Object.keys(a)[0];
  if (!embedType || embedType !== Object.keys(b)[0]) {
    throw new Error("embed types not matched: ".concat(embedType, " != ").concat(Object.keys(b)[0]));
  }
  return [embedType, a[embedType], b[embedType]];
};
var Delta = /*#__PURE__*/function () {
  function Delta(ops) {
    _classCallCheck(this, Delta);
    // Assume we are given a well formed ops
    if (Array.isArray(ops)) {
      this.ops = ops;
    } else if (ops != null && Array.isArray(ops.ops)) {
      this.ops = ops.ops;
    } else {
      this.ops = [];
    }
  }
  _createClass(Delta, [{
    key: "insert",
    value: function insert(arg, attributes) {
      var newOp = {};
      if (typeof arg === 'string' && arg.length === 0) {
        return this;
      }
      newOp.insert = arg;
      if (attributes != null && _typeof(attributes) === 'object' && Object.keys(attributes).length > 0) {
        newOp.attributes = attributes;
      }
      return this.push(newOp);
    }
  }, {
    key: "delete",
    value: function _delete(length) {
      if (length <= 0) {
        return this;
      }
      return this.push({
        "delete": length
      });
    }
  }, {
    key: "retain",
    value: function retain(length, attributes) {
      if (typeof length === 'number' && length <= 0) {
        return this;
      }
      var newOp = {
        retain: length
      };
      if (attributes != null && _typeof(attributes) === 'object' && Object.keys(attributes).length > 0) {
        newOp.attributes = attributes;
      }
      return this.push(newOp);
    }
  }, {
    key: "push",
    value: function push(newOp) {
      var index = this.ops.length;
      var lastOp = this.ops[index - 1];
      newOp = cloneDeep(newOp);
      if (_typeof(lastOp) === 'object') {
        if (typeof newOp["delete"] === 'number' && typeof lastOp["delete"] === 'number') {
          this.ops[index - 1] = {
            "delete": lastOp["delete"] + newOp["delete"]
          };
          return this;
        }
        // Since it does not matter if we insert before or after deleting at the same index,
        // always prefer to insert first
        if (typeof lastOp["delete"] === 'number' && newOp.insert != null) {
          index -= 1;
          lastOp = this.ops[index - 1];
          if (_typeof(lastOp) !== 'object') {
            this.ops.unshift(newOp);
            return this;
          }
        }
        if (isEqual(newOp.attributes, lastOp.attributes)) {
          if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
            this.ops[index - 1] = {
              insert: lastOp.insert + newOp.insert
            };
            if (_typeof(newOp.attributes) === 'object') {
              this.ops[index - 1].attributes = newOp.attributes;
            }
            return this;
          } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
            this.ops[index - 1] = {
              retain: lastOp.retain + newOp.retain
            };
            if (_typeof(newOp.attributes) === 'object') {
              this.ops[index - 1].attributes = newOp.attributes;
            }
            return this;
          }
        }
      }
      if (index === this.ops.length) {
        this.ops.push(newOp);
      } else {
        this.ops.splice(index, 0, newOp);
      }
      return this;
    }
  }, {
    key: "chop",
    value: function chop() {
      var lastOp = this.ops[this.ops.length - 1];
      if (lastOp && typeof lastOp.retain === 'number' && !lastOp.attributes) {
        this.ops.pop();
      }
      return this;
    }
  }, {
    key: "filter",
    value: function filter(predicate) {
      return this.ops.filter(predicate);
    }
  }, {
    key: "forEach",
    value: function forEach(predicate) {
      this.ops.forEach(predicate);
    }
  }, {
    key: "map",
    value: function map(predicate) {
      return this.ops.map(predicate);
    }
  }, {
    key: "partition",
    value: function partition(predicate) {
      var passed = [];
      var failed = [];
      this.forEach(function (op) {
        var target = predicate(op) ? passed : failed;
        target.push(op);
      });
      return [passed, failed];
    }
  }, {
    key: "reduce",
    value: function reduce(predicate, initialValue) {
      return this.ops.reduce(predicate, initialValue);
    }
  }, {
    key: "changeLength",
    value: function changeLength() {
      return this.reduce(function (length, elem) {
        if (elem.insert) {
          return length + Op_1["default"].length(elem);
        } else if (elem["delete"]) {
          return length - elem["delete"];
        }
        return length;
      }, 0);
    }
  }, {
    key: "length",
    value: function length() {
      return this.reduce(function (length, elem) {
        return length + Op_1["default"].length(elem);
      }, 0);
    }
  }, {
    key: "slice",
    value: function slice() {
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
      var ops = [];
      var iter = new OpIterator_1["default"](this.ops);
      var index = 0;
      while (index < end && iter.hasNext()) {
        var nextOp = void 0;
        if (index < start) {
          nextOp = iter.next(start - index);
        } else {
          nextOp = iter.next(end - index);
          ops.push(nextOp);
        }
        index += Op_1["default"].length(nextOp);
      }
      return new Delta(ops);
    }
  }, {
    key: "compose",
    value: function compose(other) {
      var thisIter = new OpIterator_1["default"](this.ops);
      var otherIter = new OpIterator_1["default"](other.ops);
      var ops = [];
      var firstOther = otherIter.peek();
      if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
        var firstLeft = firstOther.retain;
        while (thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft) {
          firstLeft -= thisIter.peekLength();
          ops.push(thisIter.next());
        }
        if (firstOther.retain - firstLeft > 0) {
          otherIter.next(firstOther.retain - firstLeft);
        }
      }
      var delta = new Delta(ops);
      while (thisIter.hasNext() || otherIter.hasNext()) {
        if (otherIter.peekType() === 'insert') {
          delta.push(otherIter.next());
        } else if (thisIter.peekType() === 'delete') {
          delta.push(thisIter.next());
        } else {
          var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
          var thisOp = thisIter.next(length);
          var otherOp = otherIter.next(length);
          if (otherOp.retain) {
            var newOp = {};
            if (typeof thisOp.retain === 'number') {
              newOp.retain = typeof otherOp.retain === 'number' ? length : otherOp.retain;
            } else {
              if (typeof otherOp.retain === 'number') {
                if (thisOp.retain == null) {
                  newOp.insert = thisOp.insert;
                } else {
                  newOp.retain = thisOp.retain;
                }
              } else {
                var action = thisOp.retain == null ? 'insert' : 'retain';
                var _getEmbedTypeAndData = getEmbedTypeAndData(thisOp[action], otherOp.retain),
                  _getEmbedTypeAndData2 = _slicedToArray(_getEmbedTypeAndData, 3),
                  embedType = _getEmbedTypeAndData2[0],
                  thisData = _getEmbedTypeAndData2[1],
                  otherData = _getEmbedTypeAndData2[2];
                var handler = Delta.getHandler(embedType);
                newOp[action] = _defineProperty({}, embedType, handler.compose(thisData, otherData, action === 'retain'));
              }
            }
            // Preserve null when composing with a retain, otherwise remove it for inserts
            var attributes = AttributeMap_1["default"].compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
            if (attributes) {
              newOp.attributes = attributes;
            }
            delta.push(newOp);
            // Optimization if rest of other is just retain
            if (!otherIter.hasNext() && isEqual(delta.ops[delta.ops.length - 1], newOp)) {
              var rest = new Delta(thisIter.rest());
              return delta.concat(rest).chop();
            }
            // Other op should be delete, we could be an insert or retain
            // Insert + delete cancels out
          } else if (typeof otherOp["delete"] === 'number' && (typeof thisOp.retain === 'number' || _typeof(thisOp.retain) === 'object' && thisOp.retain !== null)) {
            delta.push(otherOp);
          }
        }
      }
      return delta.chop();
    }
  }, {
    key: "concat",
    value: function concat(other) {
      var delta = new Delta(this.ops.slice());
      if (other.ops.length > 0) {
        delta.push(other.ops[0]);
        delta.ops = delta.ops.concat(other.ops.slice(1));
      }
      return delta;
    }
  }, {
    key: "diff",
    value: function diff(other, cursor) {
      if (this.ops === other.ops) {
        return new Delta();
      }
      var strings = [this, other].map(function (delta) {
        return delta.map(function (op) {
          if (op.insert != null) {
            return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
          }
          var prep = delta === other ? 'on' : 'with';
          throw new Error('diff() called ' + prep + ' non-document');
        }).join('');
      });
      var retDelta = new Delta();
      var diffResult = _diff(strings[0], strings[1], cursor, true);
      var thisIter = new OpIterator_1["default"](this.ops);
      var otherIter = new OpIterator_1["default"](other.ops);
      diffResult.forEach(function (component) {
        var length = component[1].length;
        while (length > 0) {
          var opLength = 0;
          switch (component[0]) {
            case _diff.INSERT:
              opLength = Math.min(otherIter.peekLength(), length);
              retDelta.push(otherIter.next(opLength));
              break;
            case _diff.DELETE:
              opLength = Math.min(length, thisIter.peekLength());
              thisIter.next(opLength);
              retDelta["delete"](opLength);
              break;
            case _diff.EQUAL:
              opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
              var thisOp = thisIter.next(opLength);
              var otherOp = otherIter.next(opLength);
              if (isEqual(thisOp.insert, otherOp.insert)) {
                retDelta.retain(opLength, AttributeMap_1["default"].diff(thisOp.attributes, otherOp.attributes));
              } else {
                retDelta.push(otherOp)["delete"](opLength);
              }
              break;
          }
          length -= opLength;
        }
      });
      return retDelta.chop();
    }
  }, {
    key: "eachLine",
    value: function eachLine(predicate) {
      var newline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '\n';
      var iter = new OpIterator_1["default"](this.ops);
      var line = new Delta();
      var i = 0;
      while (iter.hasNext()) {
        if (iter.peekType() !== 'insert') {
          return;
        }
        var thisOp = iter.peek();
        var start = Op_1["default"].length(thisOp) - iter.peekLength();
        var index = typeof thisOp.insert === 'string' ? thisOp.insert.indexOf(newline, start) - start : -1;
        if (index < 0) {
          line.push(iter.next());
        } else if (index > 0) {
          line.push(iter.next(index));
        } else {
          if (predicate(line, iter.next(1).attributes || {}, i) === false) {
            return;
          }
          i += 1;
          line = new Delta();
        }
      }
      if (line.length() > 0) {
        predicate(line, {}, i);
      }
    }
  }, {
    key: "invert",
    value: function invert(base) {
      var inverted = new Delta();
      this.reduce(function (baseIndex, op) {
        if (op.insert) {
          inverted["delete"](Op_1["default"].length(op));
        } else if (typeof op.retain === 'number' && op.attributes == null) {
          inverted.retain(op.retain);
          return baseIndex + op.retain;
        } else if (op["delete"] || typeof op.retain === 'number') {
          var length = op["delete"] || op.retain;
          var slice = base.slice(baseIndex, baseIndex + length);
          slice.forEach(function (baseOp) {
            if (op["delete"]) {
              inverted.push(baseOp);
            } else if (op.retain && op.attributes) {
              inverted.retain(Op_1["default"].length(baseOp), AttributeMap_1["default"].invert(op.attributes, baseOp.attributes));
            }
          });
          return baseIndex + length;
        } else if (_typeof(op.retain) === 'object' && op.retain !== null) {
          var _slice = base.slice(baseIndex, baseIndex + 1);
          var baseOp = new OpIterator_1["default"](_slice.ops).next();
          var _getEmbedTypeAndData3 = getEmbedTypeAndData(op.retain, baseOp.insert),
            _getEmbedTypeAndData4 = _slicedToArray(_getEmbedTypeAndData3, 3),
            embedType = _getEmbedTypeAndData4[0],
            opData = _getEmbedTypeAndData4[1],
            baseOpData = _getEmbedTypeAndData4[2];
          var handler = Delta.getHandler(embedType);
          inverted.retain(_defineProperty({}, embedType, handler.invert(opData, baseOpData)), AttributeMap_1["default"].invert(op.attributes, baseOp.attributes));
          return baseIndex + 1;
        }
        return baseIndex;
      }, 0);
      return inverted.chop();
    }
  }, {
    key: "transform",
    value: function transform(arg) {
      var priority = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      priority = !!priority;
      if (typeof arg === 'number') {
        return this.transformPosition(arg, priority);
      }
      var other = arg;
      var thisIter = new OpIterator_1["default"](this.ops);
      var otherIter = new OpIterator_1["default"](other.ops);
      var delta = new Delta();
      while (thisIter.hasNext() || otherIter.hasNext()) {
        if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
          delta.retain(Op_1["default"].length(thisIter.next()));
        } else if (otherIter.peekType() === 'insert') {
          delta.push(otherIter.next());
        } else {
          var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
          var thisOp = thisIter.next(length);
          var otherOp = otherIter.next(length);
          if (thisOp["delete"]) {
            // Our delete either makes their delete redundant or removes their retain
            continue;
          } else if (otherOp["delete"]) {
            delta.push(otherOp);
          } else {
            var thisData = thisOp.retain;
            var otherData = otherOp.retain;
            var transformedData = _typeof(otherData) === 'object' && otherData !== null ? otherData : length;
            if (_typeof(thisData) === 'object' && thisData !== null && _typeof(otherData) === 'object' && otherData !== null) {
              var embedType = Object.keys(thisData)[0];
              if (embedType === Object.keys(otherData)[0]) {
                var handler = Delta.getHandler(embedType);
                if (handler) {
                  transformedData = _defineProperty({}, embedType, handler.transform(thisData[embedType], otherData[embedType], priority));
                }
              }
            }
            // We retain either their retain or insert
            delta.retain(transformedData, AttributeMap_1["default"].transform(thisOp.attributes, otherOp.attributes, priority));
          }
        }
      }
      return delta.chop();
    }
  }, {
    key: "transformPosition",
    value: function transformPosition(index) {
      var priority = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      priority = !!priority;
      var thisIter = new OpIterator_1["default"](this.ops);
      var offset = 0;
      while (thisIter.hasNext() && offset <= index) {
        var length = thisIter.peekLength();
        var nextType = thisIter.peekType();
        thisIter.next();
        if (nextType === 'delete') {
          index -= Math.min(length, index - offset);
          continue;
        } else if (nextType === 'insert' && (offset < index || !priority)) {
          index += length;
        }
        offset += length;
      }
      return index;
    }
  }], [{
    key: "registerEmbed",
    value: function registerEmbed(embedType, handler) {
      this.handlers[embedType] = handler;
    }
  }, {
    key: "unregisterEmbed",
    value: function unregisterEmbed(embedType) {
      delete this.handlers[embedType];
    }
  }, {
    key: "getHandler",
    value: function getHandler(embedType) {
      var handler = this.handlers[embedType];
      if (!handler) {
        throw new Error("no handlers for embed type \"".concat(embedType, "\""));
      }
      return handler;
    }
  }]);
  return Delta;
}();
Delta.Op = Op_1["default"];
Delta.OpIterator = OpIterator_1["default"];
Delta.AttributeMap = AttributeMap_1["default"];
Delta.handlers = {};
exports["default"] = Delta;
if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object') {
  module.exports = Delta;
  module.exports["default"] = Delta;
}